import * as types from "../types/index";
import { core } from "./core";
import moment from "moment";

export const getProjects = (queryString) => {
  if (!queryString) {
    queryString = "more_details=false";
  }

  return core.API(
    "GET",
    `/projects${queryString ? `?${queryString}` : ""}`,
    types.GET_PROJECTS,
    types.GET_PROJECTS_SUCCESS,
    types.GET_PROJECTS_FAILURE
  );
};

export const getProjectsOverview = (queryString) => {
  return core.API(
    "GET",
    `/dashboard/hours-by-projects/${queryString ? `?${queryString}` : ""}`,
    types.GET_PROJECT_OVERVIEW,
    types.GET_PROJECT_OVERVIEW_SUCCESS,
    types.GET_PROJECT_OVERVIEW_FAILURE
  );
};

export const getProject = (data) => {
  let queryString = "";
  if (data.fromDate) {
    queryString += `start_time=${moment(data.fromDate).format("YYYY-MM-DD")}&`;

    if (data.toDate) {
      queryString += `end_time=${moment(data.toDate).format("YYYY-MM-DD")}&`;
    }
  }
  if (data.department_id) {
    queryString += `department_id=${data.department_id}&`;
  }
  queryString = queryString.slice(0, -1);

  return core.API(
    "GET",
    `/project/${data.id}?more_details=true${
      queryString ? `&${queryString}` : ""
    }`,
    types.GET_PROJECT,
    types.GET_PROJECT_SUCCESS,
    types.GET_PROJECT_FAILURE
  );
};

export const deleteProject = (id) => {
  return core.API(
    "DELETE",
    `/project/${id}`,
    types.DELETE_PROJECTS,
    types.DELETE_PROJECTS_SUCCESS,
    types.DELETE_PROJECTS_FAILURE
  );
};

export const updateProject = (id, data) => {
  return core.API(
    "PUT",
    `/project/${id}/`,
    types.PUT_PROJECTS_DATA,
    types.PUT_PROJECTS_DATA_SUCCESS,
    types.PUT_PROJECTS_DATA_FAILURE,
    data
  );
};

export const addProject = (data) => {
  return core.API(
    "POST",
    `/project/`,
    types.ADD_PROJECT,
    types.ADD_PROJECT_SUCCESS,
    types.ADD_PROJECT_FAILURE,
    data
  );
};

export const userDetialsByProject = (data) => {
  let queryString = "";
  if (data.fromDate) {
    queryString += `start_time=${moment(data.fromDate).format("YYYY-MM-DD")}&`;

    if (data.toDate) {
      queryString += `end_time=${moment(data.toDate).format("YYYY-MM-DD")}&`;
    }
  }
  if (data.department_id) {
    queryString += `department_id=${data.department_id}&`;
  }
  queryString = queryString.slice(0, -1);

  return core.API(
    "GET",
    `/project/${data.id}/users${queryString ? `?${queryString}` : ""}`,
    types.GET_USES_BY_PROJECT,
    types.GET_USES_BY_PROJECT_SUCCESS,
    types.GET_USES_BY_PROJECT_FAILURE
  );
};

export const getTopProjectsData = (queryString) => {
  return core.API(
    "GET",
    `/dashboard/hours-by-day/${queryString ? `?${queryString}` : ""}`,
    types.GET_TOP_PROJECT_OVERVIEW,
    types.GET_TOP_PROJECT_OVERVIEW_SUCCESS,
    types.GET_TOP_PROJECT_OVERVIEW_FAILURE
  );
};

export const getProjectCostData = (data) => {
  let queryString = "";
  if (data.fromDate) {
    queryString += `start_time=${moment(data.fromDate).format("YYYY-MM-DD")}&`;

    if (data.toDate) {
      queryString += `end_time=${moment(data.toDate).format("YYYY-MM-DD")}&`;
    }
  }
  if (data.department_id) {
    queryString += `department_id=${data.department_id}&`;
  }
  queryString = queryString.slice(0, -1);

  return core.API(
    "GET",
    `/project/${data.id}/costs?${queryString ? `${queryString}` : ""}`,
    types.GET_PROJECT_COST,
    types.GET_PROJECT_COST_SUCCESS,
    types.GET_PROJECT_COST_FAILURE
  );
};

export const getProjectResponsibles = () => {
  return core.API(
    "GET",
    `/project/responsibles`,
    types.GET_PROJECT_RESPONSIBLES,
    types.GET_PROJECT_RESPONSIBLES_SUCCESS,
    types.GET_PROJECT_RESPONSIBLES_FAILURE
  );
};

export const getHourAddonTypesOfProjects = (data) => {
  return core.API(
    "GET",
    `/projects/hour-addon-types`,
    types.GET_HOUR_ADDON_TYPES_OF_PROJECT,
    types.GET_HOUR_ADDON_TYPES_OF_PROJECT_SUCCESS,
    types.GET_HOUR_ADDON_TYPES_OF_PROJECT_FAILURE,
    data
  );
};
